/**
 * UUID validation regex pattern
 */
const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Check if a string is a valid UUID
 */
const isValidUUID = (value: string): boolean => {
  return UUID_REGEX.test(value);
};

/**
 * Filter and return only valid UUIDs from an array
 * @param values Array of values that might be UUIDs
 * @returns Array of valid UUID strings
 */
export const filterValidUUIDs = (
  values: (string | number | null | undefined)[]
): string[] => {
  if (!Array.isArray(values)) {
    return [];
  }

  return values
    .filter((value): value is string => {
      if (value === null || value === undefined) {
        return false;
      }
      const stringValue = String(value).trim();
      return stringValue.length > 0 && isValidUUID(stringValue);
    })
    .map(value => String(value).trim());
};
